"use client";

import { appConfig } from "@/constants";
import {
  FeatureFlagProvider,
  FiatPricingProvider,
  PassportProvider,
  QueryProvider,
} from "@/context";
import { AssetImportProvider } from "@/context/AssetImportProvider";
import { PreferencesProvider } from "@/context/PreferencesProvider";
import { ProfileDrawerProvider } from "@/context/ProfileDrawerContext";
import theme from "@/styles/theme";
import { ThemeProvider } from "@mui/material/styles";
import { LDProvider } from "launchdarkly-react-client-sdk";
import type { ReactNode } from "react";
import "../i18n";
import { BrazeProvider } from "@/context/BrazeProvider";
import { PWAInstallProvider } from "@/context/PWAInstallContext";

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <LDProvider clientSideID={appConfig.LAUNCH_DARKLY_CLIENT_ID}>
      <PWAInstallProvider>
        <PassportProvider>
          <QueryProvider>
            <PreferencesProvider>
              <FeatureFlagProvider>
                <FiatPricingProvider>
                  <AssetImportProvider>
                    <ProfileDrawerProvider>
                      <BrazeProvider>
                        <ThemeProvider theme={theme}>{children}</ThemeProvider>
                      </BrazeProvider>
                    </ProfileDrawerProvider>
                  </AssetImportProvider>
                </FiatPricingProvider>
              </FeatureFlagProvider>
            </PreferencesProvider>
          </QueryProvider>
        </PassportProvider>
      </PWAInstallProvider>
    </LDProvider>
  );
}
